import React from 'react';

import api from '~/services/api';
import { Label, Input, TextArea } from '~/componentes/CustomForm';

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';

function CreateContent() {
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let response;

        response = await api.post(
          '/signed/empresa/administracao/configuracao',
          {
            ...data,
          },
        );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar esse Item de Configuração, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar esse Item de Configuração?`,
        successModal: `Item de Configuração cadastrado com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMin="62vh" autoHeightMax="62vh">
        <Materialize className="padding-form">
          <div className="row header">
            <p className="h-titulo">Crie um novo Item de Configuração</p>
            <p className="h-descricao">Preencha as informações e salve</p>
          </div>
          <div className="row">
            <Label title="Título *" className="col s12 m12 l12">
              <Input name="titulo" />
            </Label>
          </div>
          <div className="row">
            <Label title="Descrição: " className="col s12 m12 l12">
              <TextArea name="descricao" />
            </Label>
          </div>
          <div className="row">
            <Label title="Valor *" className="col s12 m12 l12">
              <Input name="valor" />
            </Label>
          </div>
        </Materialize>
      </CustomScrollBar>
      <SLModalFooter />
    </Container>
  );
}

export default CreateContent;
